<span *ngIf="accessEnable">
  <div class="alert alert-danger alert-dismissible " *ngIf="errorMessage!=''" role="alert">
    {{errorMessage}}<mat-icon class="close-icon" (click)="closeAlert()">close</mat-icon>
  </div>


<div class="alert alert-success alert-dismissible " *ngIf="successMessage!=''" role="alert">
  {{successMessage}}<mat-icon class="close-icon" (click)="closeAlert()">close</mat-icon>
</div>
<mat-accordion class="example-headers-align">
  <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>

    <mat-expansion-panel-header>
      <mat-panel-title>
        <strong>Search</strong>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-form-field>
      <mat-label>NAMC</mat-label>
      <mat-select [typeaheadDebounceInterval]= "500" [(ngModel)]="namc" name="namc" (selectionChange)='getFamily();getPcSpecHps();getHikiate()'>
        <mat-option [value]=""></mat-option>
        <mat-option *ngFor="let namc of namcLst" [value]="namc.namc_lgl_entity_id">{{namc.namc_cd}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Family</mat-label>
      <mat-select [typeaheadDebounceInterval]= "500" [(ngModel)]="family" name="family" (selectionChange)='getKatashikiHps()'>
        <mat-option [value]=""></mat-option>
        <mat-option *ngFor="let family of famcdLst" [value]="family.fam_cd">{{family.fam_cd}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Katashiki</mat-label>
      <mat-select [typeaheadDebounceInterval]= "500" [(ngModel)]="katashiki" name="katashiki" (selectionChange)='getDestination()'>
        <mat-option [value]=""></mat-option>
        <mat-option *ngFor="let katashiki of katashikiLst" [value]="katashiki.katashiki_cd">{{katashiki.katashiki_cd}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Dest</mat-label>
      <mat-select [typeaheadDebounceInterval]= "500" [(ngModel)]="destination" name="destination" (selectionChange)='getHikiate()'>
        <mat-option [value]=""></mat-option>
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let destination of destLst" [value]="destination.dest_ctry_id">{{destination.dest_ctry_id}}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field>
      <mat-label>Hikiate Status</mat-label>
      <mat-select [typeaheadDebounceInterval]= "500" [(ngModel)]="hikiate"  (selectionChange)='getPcSpecHps()'>
        <mat-option [value]=""></mat-option>
        <span *ngFor="let hikiate of hikiateLst">
          <span *ngIf="hikiate.hikiate_stat_comb_cd != null">
            <mat-option *ngIf="hikiate.hikiate_stat_comb_cd != ''" [value]="hikiate.hikiate_stat_comb_cd">
              {{hikiate.hikiate_stat_comb_cd}}
            </mat-option>
          </span>
        </span>
      </mat-select>
    </mat-form-field>
  
    

    <mat-form-field>
      <mat-label>PC Spec</mat-label>
      <mat-select [typeaheadDebounceInterval]= "500" [(ngModel)]="pcSpec" name="pcSpec">
        <mat-option [value]=""></mat-option>
        <mat-option *ngFor="let pcSpec of pcSpecLst" [value]="pcSpec.pc_spec_cd_comb_txt">{{pcSpec.pc_spec_cd_comb_txt}}
        </mat-option>
      </mat-select>
    </mat-form-field>
   
    <mat-form-field class="picker">
      <mat-label>Time In-Date</mat-label>
      <input matInput [matDatepicker]="inPicker" [(ngModel)]="timeInDt" >
      <mat-datepicker-toggle matSuffix [for]="inPicker"></mat-datepicker-toggle>
      <mat-datepicker #inPicker ></mat-datepicker>
      <mat-icon matDatepickerToggleIcon class="dateclear" (click)="clearDate($event,'timeInDt')">clear</mat-icon>
    </mat-form-field>
    <mat-form-field class="picker">
      <mat-label>Time Out-Date</mat-label>
      <input matInput [matDatepicker]="outPicker" [(ngModel)]="timeOutDt">
      <mat-datepicker-toggle matSuffix [for]="outPicker"></mat-datepicker-toggle>
      <mat-datepicker #outPicker ></mat-datepicker>
      <mat-icon matDatepickerToggleIcon class="dateclear" (click)="clearDate($event,'timeOutDt')">clear</mat-icon>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Comments</mat-label>
      <input matInput placeholder="" [(ngModel)]="comments">
    </mat-form-field>

    <mat-form-field class="picker">
      <mat-label>VDW Effective In</mat-label>
      <input matInput [matDatepicker]="inVdwPicker" [(ngModel)]="vdwEffIn" >
      <mat-datepicker-toggle matSuffix [for]="inVdwPicker"></mat-datepicker-toggle>
      <mat-datepicker #inVdwPicker ></mat-datepicker>
      <mat-icon matDatepickerToggleIcon class="dateclear" (click)="clearDate($event,'vdwEffIn')">clear</mat-icon>
    </mat-form-field>
    <mat-form-field class="picker">
      <mat-label>VDW Effective Out</mat-label>
      <input matInput [matDatepicker]="outVdwPicker" [(ngModel)]="vdwEffOut" >
      <mat-datepicker-toggle matSuffix [for]="outVdwPicker"></mat-datepicker-toggle>
      <mat-datepicker #outVdwPicker></mat-datepicker>
      <mat-icon matDatepickerToggleIcon class="dateclear" (click)="clearDate($event,'vdwEffOut')">clear</mat-icon>
    </mat-form-field>
 
    <mat-form-field>
      <mat-label>100% Spec Id</mat-label>
      <input matInput placeholder="" input type="number" [(ngModel)]="hundPercent">
    </mat-form-field>
    <br>
    <button mat-button style="float: right;" (click)="resetAll('initial')">Reset</button>
    <button mat-button style="float: right;" (click)="search()">Search</button>


  </mat-expansion-panel>
</mat-accordion>

<div class="d-flex">
  <button mat-raised-button (click)="openAddDialog()">Add</button>
  <button mat-raised-button (click)="openEditDialog()">Edit</button>
  <button mat-raised-button (click)="openViewDialog()">View</button>
  <button mat-raised-button (click)="openUploadDialog()">Upload From Excel </button>
  <button mat-raised-button (click)="exportFile()" class="ms-auto">Export To Excel</button>

</div>

<ngx-datatable #myTable class="material striped" [rows]="rows" [columnMode]="ColumnMode.force" [headerHeight]="45"
  [footerHeight]="30" rowHeight="30" [limit]="limitSelected" [selected]="selected"
  [selectionType]="SelectionType.checkbox" [selectAllRowsOnPage]="false" [displayCheck]="displayCheck"
  (activate)="onActivate($event)" (select)="onSelect($event)" [scrollbarH]="true"
  [ngClass]="{'hideerror': showdata, 'showerror': !showdata }">
  <ngx-datatable-footer>
    <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
      let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
      <div class="page-count">
        {{selectedCount}} selected / {{rowCount}} total
      </div>
      <datatable-pager class="text-end" [pagerLeftArrowIcon]="'datatable-icon-left'"
        [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'"
        [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount"
        (change)="table.onFooterPage($event)">
      </datatable-pager>
      <div class="test">

        <select [(ngModel)]="limitSelected">
          <option>50</option>
          <option>100</option>
          <option>500</option>
        </select>
        <div class="float-right records">View {{(offset * pageSize)+1}} - {{(rowCount>
          (curPage*pageSize))?(curPage*pageSize):(rowCount)}} of
          {{(rowCount)}}

        </div>
      </div>
    </ng-template>
  </ngx-datatable-footer>
  <ngx-datatable-column [width]="10" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false"
    [headerCheckboxable]="true" [checkboxable]="true">
  </ngx-datatable-column>
  <ngx-datatable-column name="NAMC" prop="namc_cd"></ngx-datatable-column>
  <ngx-datatable-column name="Family" prop="fam_cd"></ngx-datatable-column>
  <ngx-datatable-column name="Katashiki" prop="katashiki_cd"></ngx-datatable-column>
  <ngx-datatable-column name="Dest" prop="dest_ctry_id"></ngx-datatable-column>
  <ngx-datatable-column name="Hikiate status" prop="hikiate_stat_comb_cd"></ngx-datatable-column>
  <ngx-datatable-column name="PC Spec" prop="pc_spec_cd_comb_txt"></ngx-datatable-column>
  <ngx-datatable-column name="Time In Date" prop="eff_dt"></ngx-datatable-column>
  <ngx-datatable-column name="Time Out Date" prop="expr_dt"></ngx-datatable-column>
  <ngx-datatable-column name="Comments" prop="cmt_txt"></ngx-datatable-column>
  <ngx-datatable-column name="VDW Effective In" prop="vdw_eff_dt"></ngx-datatable-column>
  <ngx-datatable-column name="VDW Effective Out" prop="vdw_expr_dt"></ngx-datatable-column>
  <ngx-datatable-column name="100% Spec Id" prop="reqd_100pct_pc_spec_optn_id"></ngx-datatable-column>
</ngx-datatable>
</span>
<div *ngIf="!accessEnable">
  <p class="text-center" style="margin: 25px;color: red;">{{errorMessage}}</p>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">{{spinnerMessage}} </p>
</ngx-spinner>